"use client";

import Image from "next/image";
import { Great_Vibes, Cormorant_Garamond } from "next/font/google";
import { GuestbookEntry } from "@/app/lib/weddingPortal";

const greatVibes = Great_Vibes({
  subsets: ["latin"],
  weight: "400",
});

const cormorant = Cormorant_Garamond({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700"],
});

export default function GuestbookCards({
  entries,
  emptyMessage,
  highlightedEntryId,
}: {
  entries: GuestbookEntry[];
  emptyMessage: string;
  highlightedEntryId?: string | null;
}) {
  if (entries.length === 0) {
    return (
      <div className="rounded-[1.75rem] border border-[#decf9b] bg-white px-6 py-10 text-center shadow-sm">
        <p className="text-lg text-[#686861]">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
      {entries.map((entry) => (
        <article
          key={entry.id}
          className={`relative overflow-hidden rounded-[1.75rem] border border-[#decf9b] bg-[linear-gradient(180deg,#fffdfa_0%,#f6efe2_100%)] p-6 shadow-sm transition-shadow ${entry.id === highlightedEntryId ? "guestbook-new-message-glow" : ""} ${cormorant.className}`}
        >
          <div className="absolute right-4 top-4 h-16 w-16 rounded-full bg-[#f1e4bc]/55 blur-2xl" />

          <p className="text-[11px] uppercase tracking-[.22em] text-[#8c8c86]">
            {new Date(entry.createdAt).toLocaleDateString("en-GB", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
          </p>

          <p className="mt-5 text-lg leading-8 text-[#4e5a6b]">
            “{entry.message}”
          </p>

          <div className="mt-6 border-t border-[#ead8a0] pt-4">
            {entry.signatureDataUrl ? (
              <div className="relative h-20 w-full overflow-hidden rounded-[1rem] bg-white">
                <Image
                  src={entry.signatureDataUrl}
                  alt={`Signature from ${entry.typedName || "a wedding guest"}`}
                  fill
                  unoptimized
                  className="object-contain p-2"
                />
              </div>
            ) : null}

            <p className={`${greatVibes.className} mt-4 text-4xl text-[#1f4e79]`}>
              {entry.typedName || "Anonymous Guest"}
            </p>
          </div>
        </article>
      ))}
    </div>
  );
}
